//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import divSpan from '@/components/DivSpan';
import asnNeedTp from '@/components/page-temporary/asn-needTP';
export default {
  name: "asn-need-list",
  components: {
    divSpan,
    asnNeedTp
  },
  data() {
    return {
      tabIndex: 1,
      refresh:true,
      wrapperHeight: 0,
      needDetails:[],
      allLoaded: false,
      checked:'',
      configTodo: {
        title:'待送货清单',
        url:'api/asn-dt/need/page',
        workflowSearchBean:{},
        fixRules:{},
        inputCondition:{
          placeholder:'物料编号/名称/单号/供应商',
          searchCondition:'key',
          rules:[{field: "material.matGrpCode-matName-orderNo-supplierName", option: "LIKE_ANYWHERE"}]
        },
        selectConfig:[
          {
            text: '实际收货工厂',
            type: 'search',
            condition: 'plant',
            searchCondition: {label: 'plantName', code: 'plantCode'},
            rules: [{field: "plant.plantCode-plant.plantName", option: "LIKE_ANYWHERE"}],
          },
          {
            text: '要货日期',
            type: 'date',
            isOld:true,
            rules:[{field: "requireGoodsDateFrom",collectIndex: -1,option: "BTD"}],
          }
        ]
      },
      searchData: {},
      list: [],
      showMore: true
    }
  },

  methods: {
    goDetail(asn){
      let checkListGroup = [];
      for(let i=0;i<this.list.length;i++){
        if(this.list[i].checked == true){
          checkListGroup.push(this.list[i]);
          checkListGroup.forEach(item => {
            item.receiveQty = 0;
            item.poNo = item.orderNo;
            item.purOrderErpNo = item.orderNoERP;
            item.poItemNo = item.purOrderDetail.itemNo;
            item.alw = item.purOrderDetail.alw;
            item.deliveryDate = item.requireGoodsDateFrom;
            item.requireQty = item.confirmCount;
            item.delQty = item.requireQty - item.asnCrtQty - item.asnReceiveQty;
            item.supplier = {
              id: item.supplierId,
              supplierName: item.supplierName,
              supplierCode: item.supplierCode,
            };
            item.material = item.material;
            item.materialName = item.material.matName;
            if(item.material != null){
              if(!item.material) {
                item.material = {
                  minPackNum: 0
                }
              }
              item.minPackNum = item.material['minPackNum'];
              if (item.minPackNum) {
                //向上取整
                item.boxQty = Math.ceil(item.delQty / item.minPackNum);
              }
            }
            item.unit = item.purOrderDetail.orderUnit;
            //item.checked = false;
            item.requireGoodsPlanRow = { id: item.id,planType: item.planType };
            item.sourceId = item.id;
            //delete item.id;
          });
        }
      }
      this.needDetails = checkListGroup;
      console.log(this.needDetails);
    },

    // 创建送货单
    creatNeed(){
      if(this.needDetails.length==0){
        this.$message.error('请选择需要送货的采购订单！');
        return;
      }
      let data = this.needDetails;
      let supplierCode = data[0].supplierCode;
      if (data[0].plant == null) {
        this.$message.error('工厂不能为空！');
        return;
      }
      let plantCode = data[0].plant.plantCode;
      let address = data[0].shipAddress;
      let dataCheck = true;
      const params = [];
      for(let i=0;i<data.length;i++){
        let item = data[i];
        if ( item.purOrderDetail &&  item.purOrderDetail.purOrderApproveDtId ) {
          params.push(item.purOrderDetail.purOrderApproveDtId);
        }
        if (supplierCode != item.supplierCode
          || plantCode != item.plant.plantCode
          || address != item.shipAddress) {
          dataCheck = false;
          this.$message.error('同一供应商、采购组织、工厂、送货地址才能创建送货单！');
          break;
        }
      }
      if (!dataCheck) {
        return;
      }
      if (params && params.length > 0 ) {
        this.$post('api/asn/salesFourStopStatusSap', params).then((res) => {
          localStorage.setItem("asnData", JSON.stringify(this.needDetails));
          this.$router.push("/asn/creat/"+ this.needDetails.id);
        });
      } else{
        localStorage.setItem("asnData", JSON.stringify(this.needDetails));
        this.$router.push("/asn/creat/"+ this.needDetails.id);
      }
    },
    getTabIndex(e) {
      this.tabIndex = e;
    },
    getList(e,met,bol){
      this.$nextTick(()=>{
        if(bol){
          this.list = this.list.concat(e);
        }else{
          this.list = e;
        }
        if(met === 'top'){
          this.$refs.loadmore.onTopLoaded();
        }
        if(met === 'bottom'){
          this.$refs.loadmore.onBottomLoaded();
        }
      })
    },
    init: function () {
      // 父控件要加上高度，否则会出现上拉不动的情况
      this.wrapperHeight = document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top - 10;
    },
    loadTop() {
      this.$refs.header.getlist(true);
    },
    loadBottom() {
      this.$refs.header.getMore();
    },
  },
  mounted() {
    this.init();
    this.$refs.header.tabIndex = this.$route.query.tabIndex || 1;
    this.tabIndex = this.$route.query.tabIndex || 1;
    this.$refs.header.getlist();
  }
}



// WEBPACK FOOTER //
// ./src/page/asn/asn-need-list.vue